import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import RequirementsTabContainer from './requirements/RequirementsTabContainer';
import ComponentsContainer from './components/containers/ComponentsContainer';
import PdfContainer from './pdf/containers/PdfContainer';

function SpecialPermitSettingsContainer({ match, pathName }) {
  const permissions = getJson('permissions');

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row border-bottom-row">
            <ul className="nav nav-tabs sub-tab-borongan">
              {Acl(permissions, ['VIEW SPECIAL PERMIT REQUIREMENTS TAGGING']) && (

                <li className="nav-item">
                  <Link
                    to="/special-permit/settings"
                    className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf('special-permit/settings/requirements-tagging') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Requirements Tagging
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW SPECIAL PERMIT COMPONENTS']) && (
                <li>
                  <Link
                    to="/special-permit/settings/components"
                    className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf('special-permit/settings/components') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Components
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW SPECIAL PERMIT PDF SETTINGS']) && (
                <li>
                  <Link
                    to="/special-permit/settings/pdf"
                    className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf('special-permit/settings/pdf') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    PDF
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/requirements-tagging`} />}
          />

          {Acl(permissions, ['VIEW SPECIAL PERMIT REQUIREMENTS TAGGING']) && (
            <Route
              path={`${match.path}/requirements-tagging`}
              component={RequirementsTabContainer}
            />
          )}

          {Acl(permissions, ['VIEW SPECIAL PERMIT COMPONENTS']) && (
            <Route
              path={`${match.path}/components`}
              component={ComponentsContainer}
            />
          )}

          {Acl(permissions, ['VIEW SPECIAL PERMIT PDF SETTINGS']) && (
            <Route
              path={`${match.path}/pdf`}
              component={PdfContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

SpecialPermitSettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SpecialPermitSettingsContainer);
